var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8346 14.0013C24.8346 19.9844 19.9844 24.8346 14.0013 24.8346C8.01822 24.8346 3.16797 19.9844 3.16797 14.0013C3.16797 8.01822 8.01822 3.16797 14.0013 3.16797C19.9844 3.16797 24.8346 8.01822 24.8346 14.0013ZM27.3346 14.0013C27.3346 21.3651 21.3651 27.3346 14.0013 27.3346C6.63751 27.3346 0.667969 21.3651 0.667969 14.0013C0.667969 6.63751 6.63751 0.667969 14.0013 0.667969C21.3651 0.667969 27.3346 6.63751 27.3346 14.0013ZM14.0013 12.7513C14.6917 12.7513 15.2513 13.3109 15.2513 14.0013L15.2513 19.0013C15.2513 19.6917 14.6917 20.2513 14.0013 20.2513C13.3109 20.2513 12.7513 19.6917 12.7513 19.0013L12.7513 14.0013C12.7513 13.3109 13.3109 12.7513 14.0013 12.7513Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2513 9.0013C15.2513 9.69166 14.6917 10.2513 14.0013 10.2513C13.3109 10.2513 12.7513 9.69166 12.7513 9.0013C12.7513 8.31095 13.3109 7.7513 14.0013 7.7513C14.6917 7.7513 15.2513 8.31095 15.2513 9.0013Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.6e8df45b66a71fb054b8bccae9ed0bbf.svg";
export { ForwardRef as ReactComponent };